import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import withState from 'recompose/withState';
import { connect } from 'react-redux';
import CoachListItem from './CoachListItem';

import * as fileApi from '../../http-client/endpoints/fileApi';

async function componentWillMount() {
  const { coach, getFile, setImgSrc, clientToken } = this.props;
  if (coach.photoMedia && coach.photoMedia.length > 0) {
    const [first] = coach.photoMedia;
    const file = await getFile(clientToken, first.fileId);

    if (file) {
      const arrayBufferView = new Uint8Array(file.content);
      const blob = new Blob([arrayBufferView], { type: file.type });
      const url = URL.createObjectURL(blob);
      setImgSrc(url);
    }
  }
}

export default compose(
  connect(null, { ...fileApi }),
  withState('imgSrc', 'setImgSrc', null),
  lifecycle({ componentWillMount })
)(CoachListItem);



// WEBPACK FOOTER //
// ./src/components/CoachListItem/CoachListItemContainer.js